module.exports = __webpack_public_path__ + "img/MobileDefaultFeedbackOkay.99199fc3.png";